import { Search, ListTree, GitCompare, Calculator, Sparkles } from "lucide-react";

const ICONS = {
  search: Search,
  list: ListTree,
  compare: GitCompare,
  calc: Calculator,
};

/**
 * AgentTrace — renders ARIA's live reasoning steps (tool calls) as a compact
 * vertical timeline above the answer. Shows the agent "thinking out loud".
 */
export function AgentTrace({ steps = [], streaming = false }) {
  if (!steps || steps.length === 0) return null;
  return (
    <div className="mb-3 pb-3 border-b border-current/10" data-testid="agent-trace">
      <div className="text-[9px] font-mono uppercase tracking-[0.2em] text-[var(--aria-text-muted)] mb-2 inline-flex items-center gap-1.5">
        <Sparkles size={10} className="text-[var(--aria-primary)]" /> Reasoning
      </div>
      <div className="space-y-1.5">
        {steps.map((s, i) => {
          const Icon = ICONS[s.icon] || Search;
          const last = i === steps.length - 1;
          return (
            <div key={i} data-testid={`agent-step-${i}`}
              className="flex items-start gap-2 text-xs fade-in">
              <span className="mt-0.5 shrink-0 w-4 h-4 rounded-sm flex items-center justify-center border border-[var(--aria-primary)]/30 bg-[var(--aria-primary)]/8">
                <Icon size={10} className="text-[var(--aria-primary)]" />
              </span>
              <div className="min-w-0">
                <span className="text-[var(--aria-text)] font-medium">{s.label}</span>
                {s.detail && (
                  <span className="text-[var(--aria-text-muted)]"> · {s.detail}</span>
                )}
                {streaming && last && (
                  <span className="ml-1 inline-block w-1 h-1 rounded-full bg-[var(--aria-primary)] animate-pulse" />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
